import { render } from "./AppClr.vue?vue&type=template&id=52fe425c"
import script from "./AppClr.vue?vue&type=script&lang=js"
export * from "./AppClr.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__